import React from "react";
import Heading from "../Heading";
import { FastestGrowingStyles } from "../Styles";
import GlobalSubHeading from "../GlobalSubHeading";
import { getMeaning } from "../../utils/localization";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { Box, Grid, Card, Typography } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const FEATURES = [
  {
    icon: <AccountCircleIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.CSTMRS1"),
    count: getMeaning("HME.CSTMRS2"),
    description: getMeaning("HME.CSTMRS3"),
  },
  {
    icon: <AccountCircleIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.CSTMRS1"),
    count: getMeaning("HME.CLMSTLMNT1"),
    description: getMeaning("HME.CLMSTLMNT2"),
  },
  {
    icon: <AccountCircleIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.CSTMRS1"),
    count: getMeaning("HME.EMPNPS1"),
    description: getMeaning("HME.EMPNPS2"),
  },
  {
    icon: <AccountCircleIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.SRVDCLNTS1"),
    count: getMeaning("HME.SRVDCLNTS2"),
    description: getMeaning("HME.SRVDCLNTS3"),
  },
  {
    icon: <AccountCircleIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.CSTMRS1"),
    count: getMeaning("HME.PINSRVD1"),
    description: getMeaning("HME.PINSRVD2"),
  },
  {
    icon: <AccountCircleIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.GLNLNTWRK1"),
    count: getMeaning("HME.GLNLNTWRK2"),
    description: getMeaning("HME.GLNLNTWRK3"),
  },
  {
    icon: <AccountCircleIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.RTNG1"),
    count: "4.6",
    percent: "5",
    description: getMeaning("HME.RTNG3"),
  },
  {
    icon: <AccountCircleIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.CSTMRS1"),
    count: getMeaning("HME.ASCOATS1"),
    description: getMeaning("HME.ASCOATS2"),
  },
];

const FastestGrowing = () => {
  return (
    <Box sx={FastestGrowingStyles.root}>
      <Heading title={getMeaning("HME.FSTSTGRWNG")} />

      <Box align="center">
        <GlobalSubHeading subTitle={getMeaning("HME.FSTSTGRWNGDESCP")} />
      </Box>

      <Grid container spacing={2} mt={4} justifyContent="center">
        {FEATURES.map((item, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            lg={3}
            key={index}
            sx={FastestGrowingStyles.gridItem}
          >
            <Box sx={FastestGrowingStyles.cardWrapper}>
              <Card sx={FastestGrowingStyles.card}>
                <Box sx={FastestGrowingStyles.cardTopSection}>
                  <Box sx={FastestGrowingStyles.iconCircle}>
                    <TrendingUpIcon sx={{ color: "#0052CC", fontSize: 20 }} />
                  </Box>
                  <Typography
                    variant="body2"
                    sx={FastestGrowingStyles.cardTitle}
                  >
                    {item?.title}
                  </Typography>
                </Box>
                <Typography
                  display="flex"
                  variant="h4"
                  sx={FastestGrowingStyles.cardCount}
                >
                  {item?.count}
                  {item?.percent && (
                    <Typography
                      variant="body2"
                      sx={FastestGrowingStyles.cardTitle}
                      // style={{ marginTop: 10 }}
                    >
                      /
                    </Typography>
                  )}
                  <Typography
                    variant="body2"
                    sx={FastestGrowingStyles.cardTitle}
                    // style={{ marginTop: 12 }}
                  >
                    {item?.percent}
                  </Typography>
                </Typography>

                <Typography
                  variant="body2"
                  sx={FastestGrowingStyles.cardDescription}
                >
                  {item?.description}
                </Typography>
                {/* <Box sx={FastestGrowingStyles.bottomLine} /> */}
              </Card>
            </Box>
          </Grid>
        ))}
      </Grid>
      {/* </Container> */}
    </Box>
  );
};

export default FastestGrowing;
